<template>
    <div class="mb-6 space-y-3">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-gray-200">
            {{ title }}
        </h1>

        <!-- Breadcrumb -->
        <nav
            class="text-sm text-gray-500 mb-6"
            aria-label="Breadcrumb"
        >
            <ol class="flex items-center space-x-2">
                <li class="flex items-center space-x-2">
                    <inertia-link
                        :href="homeUrl"
                        class="text-green-600 hover:underline dark:text-gray-200"
                    >
                        {{ homeLabel }}
                    </inertia-link>
                    <ChevronIcon />
                </li>

                <li
                    v-for="(item, index) in items"
                    :key="index"
                    class="flex items-center"
                >
                    <template v-if="item.href">
                        <inertia-link
                            :href="item.href"
                            class="text-green-600 dark:text-gray-200 line-clamp-1 hover:underline"
                        >
                            {{ item.label }}
                        </inertia-link>
                    </template>
                    <template v-else>
                        <span class="text-gray-800 dark:text-gray-200 line-clamp-1">
                            {{ item.label }}
                        </span>
                    </template>
                    <ChevronIcon v-if="index !== items.length - 1" />
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
    import ChevronIcon from './Icons/ChevronIcon.vue';

    export default {
        name: 'Breadcrumb',
        components: { ChevronIcon },
        props: {
            title: {
                type: String,
                default: '',
            },
            items: {
                type: Array,
                required: true,
            },
            homeLabel: {
                type: String,
                default: 'Home',
            },
            homeUrl: {
                type: String,
                default: '/',
            },
        },
    };
</script>
